import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 192; //256;

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    maxWidth: "100vw"
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  app: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    maxWidth: "100vw"
  }
}));

export { useStyles, drawerWidth };
